import React, { useState } from "react";
import styled from "styled-components";
import { FiSquare, FiCheckSquare } from "react-icons/fi";

interface CustomCheckboxProps {
  color: any;
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: any;
}

const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 8px;
  margin-top: 20px;
  margin-bottom: 20px;
`;

const CheckboxLabel = styled.label`
  display: inline-block;
  font-size: 10px;
  margin-left: 6px;
  user-select: none;
  font-family: "Arimo", sans-serif;
  text-align: justify;
  color: #605f5f;
`;

const CustomCheckbox: React.FC<CustomCheckboxProps> = ({
  color,
  checked,
  onChange,
  label,
}) => {
  const [isChecked, setIsChecked] = useState(checked);

  const handleChange = () => {
    setIsChecked(!isChecked);
    onChange(!isChecked);
  };

  return (
    <CheckboxWrapper>
      <h1
      style={{display: 'flex', fontSize: 20, alignSelf: 'flex-start', justifyContent: 'flex-start', textAlign: 'start', color: color}}
        // src={isChecked ? require("../assets/checkbox-checked.png") : require("../assets/checkbox-unchecked.png")}
        // src={isChecked ? <FiSquare/> : <FiCheckSquare/>}

        // alt=""
        onClick={handleChange}
      >
        {!isChecked ? <FiSquare /> : <FiCheckSquare />}
      </h1>

      {label && <CheckboxLabel>{label}</CheckboxLabel>}
    </CheckboxWrapper>
  );
};

export default CustomCheckbox;
